import React, { useMemo } from 'react';
import { Box } from '@mui/material';

import GraphTimeline from 'components/GraphTimeline';
import { useDayNightShadingBackground } from 'components/DayNightShading';
import type { SunlightTimes } from 'types/sunlightTimes';
import type { SurfData } from 'types/surf';
import GraphSurf from '../GraphSurf';

import styles from './GraphSurfContainer.module.scss';

interface GraphSurfContainerProps {
  activeHour?: number;
  data: SurfData;
  dataTestId?: string;
  day: number;
  dayIndex?: number;
  isMobile: boolean;
  showTimeline: boolean;
  sunlightTimes: SunlightTimes;
}

const GraphSurfContainer: React.FC<GraphSurfContainerProps> = ({
  activeHour,
  data,
  day,
  dayIndex,
  isMobile,
  showTimeline,
  sunlightTimes,
  dataTestId = 'graph-surf-container',
}) => {
  const { background } = useDayNightShadingBackground({ sunlightTimes, dayIndex: day });

  const styleBackground = useMemo(() => ({ background }), [background]);

  return (
    <Box className={styles.shadingContainer} style={styleBackground} data-testid={dataTestId}>
      <GraphSurf
        activeHour={activeHour}
        data={data}
        day={day}
        dayIndex={dayIndex}
        isMobile={isMobile}
      />
      {showTimeline && <GraphTimeline day={data?.days?.[day]} showMarkers />}
    </Box>
  );
};

export default GraphSurfContainer;
